package lacaravana.domain

import lacaravana.app.Database

data class CajaData(val id: String, val fecha: String, val turno: Int, val estado: String, val totalCents: Int)
data class TicketData(val id: String, val pedidoId: String, val cajaId: String, val totalCents: Int, val metodoPago: String, val createdAt: String)

object Caja {
    suspend fun findOpen(db: Database): CajaData? {
        val rows = db.query("SELECT id, fecha, turno, estado, total_cents FROM caja WHERE estado = 'abierta'")
        return rows.firstOrNull()?.let {
            CajaData(
                id = it[0] as String, fecha = it[1] as String,
                turno = (it[2] as Number).toInt(), estado = it[3] as String,
                totalCents = (it[4] as Number).toInt()
            )
        }
    }

    suspend fun open(db: Database): String {
        val id = js("crypto.randomUUID()") as String
        db.execute("INSERT INTO caja (id) VALUES (?)", arrayOf(id))
        return id
    }

    suspend fun close(db: Database, cajaId: String) {
        val tickets = ticketsFor(db, cajaId)
        val total = tickets.sumOf { it.totalCents }
        db.execute(
            "UPDATE caja SET estado = 'cerrada', total_cents = ?, updated_at = datetime('now') WHERE id = ?",
            arrayOf(total, cajaId)
        )
    }

    suspend fun cobrar(db: Database, cajaId: String, pedidoId: String, metodoPago: String): String {
        val items = Pedido.itemsFor(db, pedidoId)
        val total = items.sumOf { it.precioCents * it.cantidad }
        val ticketId = js("crypto.randomUUID()") as String
        db.execute(
            "INSERT INTO tickets (id, pedido_id, caja_id, total_cents, metodo_pago) VALUES (?, ?, ?, ?, ?)",
            arrayOf(ticketId, pedidoId, cajaId, total, metodoPago)
        )
        db.execute(
            "UPDATE pedidos SET estado = 'cerrado', updated_at = datetime('now') WHERE id = ?",
            arrayOf(pedidoId)
        )
        val pedidoRows = db.query("SELECT mesa_id FROM pedidos WHERE id = ?", arrayOf(pedidoId))
        if (pedidoRows.isNotEmpty()) {
            val mesaId = (pedidoRows[0][0] as Number).toInt()
            db.execute("UPDATE mesas SET estado = 'libre', updated_at = datetime('now') WHERE id = ?", arrayOf(mesaId))
        }
        return ticketId
    }

    suspend fun ticketsFor(db: Database, cajaId: String): List<TicketData> =
        db.query(
            "SELECT id, pedido_id, caja_id, total_cents, metodo_pago, created_at FROM tickets WHERE caja_id = ? ORDER BY created_at",
            arrayOf(cajaId)
        ).map { row ->
            TicketData(
                id = row[0] as String, pedidoId = row[1] as String,
                cajaId = row[2] as String, totalCents = (row[3] as Number).toInt(),
                metodoPago = row[4] as String, createdAt = row[5] as String
            )
        }
}
